import classNames from 'classnames';
import { ElementType, FC, MouseEventHandler, MutableRefObject, PropsWithChildren } from 'react';

import { IcArrowDown16Icon, IcSelectDownIcon } from '@gem/icons';

import { IconView, IconViewSizes } from '../IconView/IconView';
import styles from './SelectorButton.styles.m.css';

export type TSelectorButtonTheme =
  | 'standard'
  | 'without-background'
  | 'without-background-secondary';

interface ISelectorButtonProps {
  className?: string;
  isActive?: boolean;
  title?: string;
  isDisabled?: boolean;
  label?: string;
  theme?: TSelectorButtonTheme;
  Icon?: ElementType;
  dataTest?: string;
  setRef: MutableRefObject<HTMLButtonElement | null>;
  onClick(): void;
}

export const SelectorButton: FC<PropsWithChildren<ISelectorButtonProps>> = (props) => {
  const {
    className,
    isDisabled,
    theme = 'standard',
    Icon,
    label,
    isActive,
    title,
    setRef,
    onClick,
    dataTest,
  } = props;

  const containerClassName = classNames(className, styles.container, styles[`theme-${theme}`], {
    [styles.active]: isActive,
  });

  const SelectIcon = theme === 'standard' ? IcSelectDownIcon : IcArrowDown16Icon;

  const selectIconSize = theme === 'standard' ? IconViewSizes.Medium : IconViewSizes.Small;

  const handleMouseDown: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
  };

  return (
    <button
      type="button"
      ref={setRef}
      onClick={onClick}
      disabled={isDisabled}
      className={containerClassName}
      onMouseDown={handleMouseDown}
      data-test={dataTest}
    >
      <span className={styles.content}>
        {Icon && (
          <IconView
            className={styles.icon}
            Icon={Icon}
          />
        )}
        <span className={styles.textContent}>
          {label && <span className={styles.label}>{label}</span>}
          <span className={styles.text}>{title}</span>
        </span>
        <IconView
          size={selectIconSize}
          className={styles.selectIcon}
          Icon={SelectIcon}
        />
      </span>
    </button>
  );
};
